<template>
  <div v-if="modelMeasurements">
    <p
      v-for="(modelMeasurement, i) in modelMeasurements"
      :key="i"
      :class="[
        brandClasses.modelMeasurements,
        {
          '':
            i === 0 && modelMeasurements.length > 1 && modelMeasurements[0].includes('|'),
        },
      ]"
    >
      {{ modelMeasurement }}
    </p>
  </div>
</template>

<script lang="ts" setup>
const { modelMeasurements } = usePdp()
const { brandClasses } = useAppConfig().pages.pdp
</script>
